import http from './http';
import api from './api';

export { http };

export default {
  ...api,
  ...http,
};
